import type { UiTvShowBundleInfo } from '~/entities/shows/bundles'
import type { UiTvBundleInfo } from '~/entities/tv/bundles'
import type { UiVodBundleInfo } from '~/shared/interfaces'
import type { ViewRow } from '../../model/components/index.h'

import { BundleCard } from "/app/libraries/arcana/src/blocks/Cards/BundleCard/index.ts"
import { CardCorners } from "/app/libraries/arcana/src/blocks/Cards/index.ts"

import { useMemo } from 'react'
import { isPaid } from '~/features/payment'
import { addQuery } from '~/shared/routes'
import { getBundleCardConfig } from '../lib/style'

export const CustomBundleCard = ({
  item,
  row,
}: {
  row: ViewRow
  item: UiVodBundleInfo | UiTvBundleInfo | UiTvShowBundleInfo
}) => {
  const {
    rented,
    name,
    labelPrice,
    landscapeImageUrl,
    quantityText,
    link: originalLink,
  } = item

  const {
    appearance: {
      style: { posterSize },
      title,
    },
  } = row

  const { titleFont, subTitleFont, verticalGap } =
    getBundleCardConfig(posterSize)

  const link = useMemo(() => {
    const contentType = row?.appearance.contentType
    const routeName =
      contentType === 'TV_BUNDLE'
        ? 'Extras/TV'
        : contentType === 'TV_SHOW_BUNDLE'
          ? 'Extras/TvShows'
          : 'Extras/Movies'

    return addQuery(originalLink, { routeName, categoryName: title })
  }, [originalLink, row, title])

  return (
    <a href={link}>
      <BundleCard
        corners={CardCorners.CORNERS_25}
        title={name}
        subtitle={quantityText}
        purchaseTitle={labelPrice}
        rented={rented}
        posterUrl={landscapeImageUrl}
        fontSubtitle={subTitleFont}
        fontTitle={titleFont}
        verticalGap={verticalGap}
        paid={isPaid(item)}
      />
    </a>
  )
}
